import LoadingSpinner from '../../Helpers/LoadingSpinner';
import useVerifySessionAuth0 from '../../Hooks/useVerifySessionAuth0';
import useLoginAuth0Handler from '../../Hooks/useLoginAuth0Handler';
import { useStore } from '../../Store/storeProvider';
import { useAuth0 } from '@auth0/auth0-react';
import { getAuth0TokensFromCache, setAuth0TokensCookies } from '../../Helpers/Auth0CookieManager';
import { GetOriginId } from '../../Helpers/Origin';
import getSegmentAndGaFromCookies from '../../Helpers/getSegmendAndGaFromCookies';
import * as storage from '../../Helpers/Auth0StorageManager';

const Auth0Login = () => {
    const [loginAuth0Handler] = useLoginAuth0Handler();
    const { Config } = useStore();
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    const { segment, ga } = getSegmentAndGaFromCookies();

    const loginHandler = async (isVerified) => {
        storage.setSitioId(Config.SitioId);
        storage.setModo(Config.Modo);
        if (isAuthenticated) {
            if (isVerified) {
                const { finalRefreshToken, idToken, accessToken } = getAuth0TokensFromCache();
                setAuth0TokensCookies(accessToken, finalRefreshToken, idToken)
                await loginAuth0Handler();
            } else if (isVerified === false) {
                storage.setCallbackEmailVerification(Config.URLCallback);
                window.location = `${window.location.origin}/auth0-emailConfirmation`
            }
        }
        else {
            const origenId = GetOriginId(Config.SitioId, Config.URLCallback);
            storage.setCallbackResetPassword(Config.URLCallback);
            loginWithRedirect({
                callbackURL: `${window.btoa(Config.URLCallback)}`,
                modo: `${Config.Modo}`,
                origen: origenId,
                "ext-origen": `${origenId}`,
                prompt: 'login',
                redirectUri: `${window.location.origin}/auth0-callback/?callback=${window.btoa(Config.URLCallback)}`,
                segment: segment,
                ga: ga
            });
        }
    }
    const [isLoadingProcess] = useVerifySessionAuth0(loginHandler);

    return (
        <div className='callback-view containerSpinner'>
            <LoadingSpinner isLoading={isLoadingProcess}>
            </LoadingSpinner>
        </div>
    );
}

export default Auth0Login;